import React, { useEffect, useState } from 'react';
import { FcLock } from "react-icons/fc";
import { FcUnlock } from "react-icons/fc";
import Swal from "sweetalert2";

import './UserCard.css'; // Importar los estilos


const UserCard = ({ user, socket }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [disabled, setDisabled] = useState(user.disabled)
    const [saldo, setSaldo] = useState(0)
    const [isAdmin, setIsAdmin] = useState(false)
    //console.log('esto es user.disabled', user.disabled)
    useEffect(()=>{
        setSaldo(user.saldo)
        if(user.typeUser==='admin'){
            setIsAdmin(true)
        }
    },[])

    useEffect(()=>{
        socket.on('ResponsSupen',(response)=>{
            if(response.uid===user.uid){
                if(response.success){
                    setDisabled(true)
                }
                Swal.fire(response.message)
            }
        })
        socket.on('ResponseEnable',(response)=>{
            if(response.uid===user.uid){
                if(response.success){
                    setDisabled(false)
                }
                Swal.fire(response.message)
            }
        })
        socket.on('Users2', (users)=>{
            console.log('se recibio user2')
            // setDataUsers(users)
        })
    },[socket, user.uid])
    const toggleDetails = () => {
        setIsOpen(!isOpen);
    };
    const Suspen = ()=>{
        socket.emit('suspen', {id:user.uid})
    }
    const Enable = ()=>{
        socket.emit('enable', {id:user.uid})
    }
    return (
        <div className={"user-card " + user.typeUser}>
            <div className={disabled ? "user-header disable" : "user-header"} onClick={toggleDetails}>
                <p>{user.nombre}</p>
                {isAdmin ? <p>Admin</p> : <p className='saldo'>{saldo}</p>}
                {user.tokenMesseger ? <p>🟢</p> : ""}
                {/* <p>{isAdmin? 'Admin': saldo}</p> */}
                <button className="toggle-btn">{isOpen ? '−' : '+'}</button>
            </div>
            {isOpen && (
                <div className="user-details">
                    <div className="details-header">
                        <img className="user-photo" src={user.data.photoURL} alt={`${user.nombre}`} />
                        {!isAdmin && (
                            <>
                            {disabled ? <FcUnlock className='icon-look' onClick={Enable}/> : <FcLock className='icon-look' onClick={Suspen}/>}
                            </>
                        )}

                    </div>
                    {disabled && (
                        <p><strong>Suspendido</strong></p>
                    )}
                    <table className='table-data'>
                        <tbody>
                            <tr>
                                <td><strong>Correo:</strong></td>
                                <td>{user.correo}</td>
                            </tr>
                            <tr>
                                <td><strong>Saldo:</strong></td>
                                <td>${saldo}</td>
                            </tr>
                            <tr>
                                <td><strong>tipo de usuario:</strong></td>
                                <td>{user.typeUser}</td>
                            </tr>
                            <tr>
                                <td><strong>Nequi:</strong></td>
                                <td>{user.nequi}</td>
                            </tr>
                            <tr>
                                <td><strong>Telefono:</strong></td>
                                <td>{user.tel}</td>
                            </tr>
                            <tr>
                                <td><strong>UID:</strong></td>
                                <td>{user.data.uid}</td>
                            </tr>
                            {/* <tr>
                                <td><strong>Último inicio:</strong></td>
                                <td>{new Date(user.data.metadata.lastSignInTime).toLocaleString()}</td>
                            </tr>
                            <tr>
                                <td><strong>Creación:</strong></td>
                                <td>{new Date(user.metadata.creationTime).toLocaleString()}</td>
                            </tr> */}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default UserCard;
